import useSearchBranch from 'api/branch/useSearchBranch/useSearchBranch';
import useCardexList from 'api/cardex/useCardexList';
import useDownloadCardex from 'api/cardex/useDownloadCardex';
import useSearchZone from 'api/locationZone/useSearchZone/useSearchZone';
import useDeleteProduct from 'api/productsList/useDeleteProduct/useDeleteProduct';
import useProductsList from 'api/productsList/useProductsList/useProductsList';
import useDownloadStockTakeReport from 'api/stockTake/useDownloadStockTakeReport';
import { CartexToolbar } from 'components/private/Cardex/CartexToolbar';
import { StockTakeToolbar } from 'components/private/StockTake/StockTakeToolbar';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import ProductsListEditModal from 'components/shared/Modals/productsList/ProductsListEditModal/ProductsListEditModal';
import ProductsListInsertModal from 'components/shared/Modals/productsList/ProductsListInsertModal/ProductsListInsertModal';
import PageSpinner from 'components/shared/pageSpinner/PageSpinner';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useStockTakeList from 'hooks/stockTake/useStockTakeList';
import useStockTakeTableColumns from 'hooks/stockTake/useStockTakeTableColumns';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// last search string
const lastSearch = null;

const StockTake = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('10');
  const [getStockTakeList, loading, stockTakeList, pageRef] =
    useStockTakeList();
  const [downloadStockTakeReport, downloadLoading] =
    useDownloadStockTakeReport();
  const tableRef = useRef(null);

  const [searchZones, searchedZonesLoading, searchedZones] = useSearchZone();
  const [zoneInputValue, setZoneInputValue] = useState();
  const [selectedZone, setSelectedZone] = useState(null);

  useEffect(() => {
    searchZones();
  }, []);

  const getReport = useCallback(
    row => () => {
      downloadStockTakeReport({ rowId: row.id, rowTitle: row.title });
    },
    [],
  );

  const [columnsData] = useStockTakeTableColumns(getReport, tableRef);

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getStockTakeList({
      page: pageNumber,
      count: pageSize,
      term: lastSearch,
      zoneGuid: selectedZone?.key,
    });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      <ApiPaginateTable
        columns={columnsData}
        rowsData={stockTakeList[page]}
        rows={stockTakeList[page]}
        pageSize={pageSize}
        disableSelection
        isLoading={selectedZone ? loading : false}
        setPageSize={val => setPageSize(val)}
        apiRef={tableRef}
        onPageChange={p => getPageData(p)}
        page={page}
        countPages={
          pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
        }
        customToolbar={() => (
          <StockTakeToolbar
            addLable="نمایش انبارگردانی"
            searchZones={searchZones}
            selectedZone={selectedZone}
            searchedZones={searchedZones}
            zoneInputValue={zoneInputValue}
            setSelectedZone={setSelectedZone}
            setZoneInputValue={setZoneInputValue}
            submitCartex={({ zoneGuid }) => {
              if (zoneGuid) {
                getStockTakeList({ zoneGuid });
              }
            }}
          />
        )}
      />
    </>
  );
};

export default StockTake;
